import angular from 'angular';

import commonModule from '../common';
import modalsModule from './modals';

import addToCartComponent from './addToCart.component';
import addToCartWithContractComponent from './addToCartWithContract.component';
import quantitySelectorComponent from './quantitySelector.component';
import productAmountComponent from './productAmount.component';
import productListComponent from './productList.component';
import relatedItemsComponent from './relatedItems.component';
import featuredProductComponent from './featuredProduct.component';

export default angular.module('fp:customerportal:shop:product', [
        commonModule.name,
        modalsModule.name
])
    .component('fpAddToCart', addToCartComponent)
    .component('fpQuantitySelector', quantitySelectorComponent)
    .component('fpProductAmount', productAmountComponent)
    .component('fpProductList', productListComponent)
    .component('fpRelatedItems', relatedItemsComponent)
    .component('fpFeaturedProduct', featuredProductComponent)
    .component('fpAddToCartWithContract', addToCartWithContractComponent);
